import React from 'react';

const ShowImage = ({src}) => {
  return (
    <div className='p-2'>
      {src && <img src={src} className='modal-height'  alt={'added image'}/>}
    </div>
  );
};

export default ShowImage;
